// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N8di","field":"styles_field__vy40D","fieldCol":"styles_fieldCol__2hIJy","diffCol":"styles_diffCol__OFF0T","diff":"styles_diff__2QhVv"};